import * as React from 'react';
import {
  Container, Link, Card, Box, Typography, Collapse, CardActionArea
} from '@mui/material'

import PageWrapper from 'components/PageWrapper';
import PageWrapperBox from 'components/PageWrapperBox';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useTranslation, Trans } from "react-i18next";

const Heading = ({children}) => <Typography sx={{fontWeight: "bold", color: "text.primary_bold", display: "inline"}}>{children}</Typography>;

export default function AboutPage() {

    const { t } = useTranslation();

    const mailLink = <Link href={"mailto:" + t("common.email")} underline="none" />;

    return <PageWrapper>
            <PageWrapperBox>
            <Typography variant="h6" fontWeight="bold" color="primary" component="div">
                {t("about.title")}
            </Typography>

            <Typography variant="body" fontWeight="light" component="div" >
            </Typography>
            </PageWrapperBox>

            <FAQ title={t("about.whoTitle")} sx={{mt: 2}}>
                <Typography sx={{color: "text.primary", mb: 3}}>
                {t("about.whoBody")}
                </Typography>
            </FAQ>

            <FAQ title={t("about.privacyTitle")}>
                <Typography sx={{color: "text.primary", mb: 3}}>
                <Heading>{t("about.privacy.heading")}</Heading><br/><br/>

                {t("about.privacy.updated")}<br/><br/>

                {t("about.privacy.intro")}<br/><br/>

                <Heading>{t("about.privacy.s1Title")}</Heading><br/><br/>

                {t("about.privacy.s1Intro")}<br/>
                - {t("about.privacy.s1Item1")}<br/>
                - {t("about.privacy.s1Item2")}<br/>
                - {t("about.privacy.s1Item3")}<br/>
                - {t("about.privacy.s1Item4")}<br/>
                - {t("about.privacy.s1Item5")}<br/>

                <br/>
                {t("about.privacy.s1Outro")}<br/><br/>

                <Heading>{t("about.privacy.s2Title")}</Heading><br/><br/>

                {t("about.privacy.s2Body")}<br/><br/>

                <Heading>{t("about.privacy.s3Title")}</Heading><br/><br/>

                {t("about.privacy.s3Body")}<br/><br/>

                <Heading>{t("about.privacy.s4Title")}</Heading><br/><br/>

                {t("about.privacy.s4Body")}<br/><br/>

                <Heading>{t("about.privacy.s5Title")}</Heading><br/><br/>

                {t("about.privacy.s5Body")}<br/><br/>

                <Heading>{t("about.privacy.s6Title")}</Heading><br/><br/>

                <Trans i18nKey="about.privacy.s6Body" components={{link: mailLink}}/><br/><br/>

                <Heading>{t("about.privacy.s7Title")}</Heading><br/><br/>

                {t("about.privacy.s7Body")}<br/><br/>

                <Heading>{t("about.privacy.s8Title")}</Heading><br/><br/>

                <Trans i18nKey="about.privacy.s8Body" components={{link: mailLink}}/>
                </Typography>
            </FAQ>


    </PageWrapper>
}

const FAQ = ({title, children, sx}) => {
    const [open, setOpen] = React.useState(false);



    return <>

    <Box sx={{backgroundColor: "primary.main", borderRadius: 2, mb: 1, ...sx}}>
        <CardActionArea sx={{flexDirection: "row", display: "flex", py: 1, px: 2, justifyContent: "flex-start"}} onClick={()=>{setOpen(!open)}}>
            <ChevronRightIcon style={{ transform: open ? "rotate(90deg)" : "rotate(0)", transition: "all 0.1s linear", color: "white" }}/>

            <Typography sx={{px: 1, color: "white"}} fontWeight="bold">{title}</Typography>
        </CardActionArea>
    </Box>

    <Collapse in={open}>
        {children}
    </Collapse>

</>}
